// Глобальная функция для проверки доступа (будет установлена из telegramAuthManager)
let checkAccessDenied = null;
let loadingIndicatorManager = null;
let userMessageManager = null;

export function setAccessDeniedChecker(checker) {
  checkAccessDenied = checker;
}

export function setLoadingIndicatorManager(manager) {
  loadingIndicatorManager = manager;
}

export function setUserMessageManager(manager) {
  userMessageManager = manager;
}

export async function safeFetch(url, options = {}) {
  // Проверяем, был ли доступ отклонен перед любым запросом
  if (checkAccessDenied && checkAccessDenied()) {
    console.warn('[safeFetch] Access denied - blocking request to:', url);
    return {
      success: false,
      error: 'access_denied',
      message: 'Доступ ограничен. Свяжитесь с командой, чтобы получить доступ.',
      status: 403
    };
  }
  
  // Показываем индикатор загрузки для длительных запросов
  const showLoading = options.showLoading !== false; // По умолчанию показываем
  const loadingKey = `fetch-${url}-${Date.now()}`;
  let loadingTimeout = null;
  
  if (showLoading && loadingIndicatorManager) {
    // Показываем индикатор только для запросов, которые могут занять время
    loadingTimeout = setTimeout(() => {
      if (loadingIndicatorManager) {
        loadingIndicatorManager.showLoading(loadingKey, {
          message: 'Загрузка...',
          type: 'spinner'
        });
      }
    }, 300); // Показываем только если запрос длится больше 300мс
  }
  
  try {
    const response = await fetch(url, options);
    const contentType = response.headers.get('content-type') || '';

    if (!response.ok) {
      let errorPayload = null;

      if (contentType.includes('application/json')) {
        try {
          errorPayload = await response.json();
        } catch (err) {
          console.warn('safeFetch: failed to parse JSON error payload', err);
        }
      } else {
        const bodyText = await response.text();
        errorPayload = { raw: bodyText };
      }

      const errorMessage = errorPayload?.message
        || errorPayload?.error
        || (errorPayload?.raw ? `${response.status} ${response.statusText || ''}`.trim() : `HTTP ${response.status}`);

      // Показываем понятное сообщение об ошибке
      if (userMessageManager && options.showError !== false) {
        userMessageManager.showError({
          error: errorPayload?.error || 'http_error',
          message: errorMessage
        }, {
          title: '❌ Ошибка',
          fallback: errorMessage
        });
      }

      return {
        success: false,
        status: response.status,
        error: errorPayload?.error || 'http_error',
        message: errorMessage,
        payload: errorPayload,
        response
      };
    }

    if (contentType.includes('application/json')) {
      const data = await response.json();
      return { success: true, data, response };
    }

    const text = await response.text();
    return { success: true, data: text, response, isText: true };
  } catch (error) {
    console.error('Ошибка fetch:', error);
    
    // Показываем понятное сообщение об ошибке сети
    if (userMessageManager && options.showError !== false) {
      userMessageManager.showError(error, {
        title: '❌ Ошибка сети',
        fallback: 'Не удалось подключиться к серверу. Проверьте интернет-соединение.'
      });
    }
    
    return { 
      success: false, 
      error: 'network_error',
      message: error.message || 'Ошибка сети'
    };
  } finally {
    // Скрываем индикатор загрузки
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
    }
    if (loadingIndicatorManager) {
      loadingIndicatorManager.hideLoading(loadingKey);
    }
  }
}

export function resolveApiUrl(defaultOrigin = window.location.origin) {
  let apiUrl = `${defaultOrigin}/api`;
  if (window.Telegram && window.Telegram.WebApp && (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1'))) {
    apiUrl = 'https://glitchlings.ru/api';
  }
  return apiUrl;
}
